import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import AmenityService from "../../services/amenity.service";

// **Async Thunks**
export const addAmenity = createAsyncThunk(
  "amenity/addAmenity",
  async (item, thunkAPI) => {
    try {
      const response = await AmenityService.addamenity(item);
      return response.data; // Return actual data
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);

export const getAmenityList = createAsyncThunk(
  "amenity/getAmenityList",
  async (item, thunkApi) => {
    try {
      const response = await AmenityService.getamenity(item);
      return response.data;
    } catch (error) {
      return thunkApi.rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);

export const editAmenity = createAsyncThunk(
  "amenity/editAmenity",
  async (item, thunkAPI) => {
    try {
      const response = await AmenityService.editamenity(item);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);

export const deleteAmenity = createAsyncThunk(
  "amenity/deleteAmenity",
  async (id, thunkAPI) => {
    try {
      await AmenityService.deleteamenity(id);
      return id; // Return only the ID to remove it from state
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);

// **Initial State**
const initialState = {
  loading: false,
  error: "",
  amenities: [],
};

// **Slice**
const amenitySlice = createSlice({
  name: "amenity",
  initialState,
  extraReducers: (builder) => {
    builder
      // **Handle Get Amenity List**
      .addCase(getAmenityList.pending, (state) => {
        state.loading = true;
        state.error = "";
      })
      .addCase(getAmenityList.fulfilled, (state, action) => {
        state.loading = false;
        state.amenities = action.payload;
      })
      .addCase(getAmenityList.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // **Handle Add Amenity**
      .addCase(addAmenity.pending, (state) => {
        state.loading = true;
      })
      .addCase(addAmenity.fulfilled, (state, action) => {
        state.loading = false;
        state.amenities.push(action.payload);
      })
      .addCase(addAmenity.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // **Handle Edit Amenity**
      .addCase(editAmenity.pending, (state) => {
        state.loading = true;
      })
      .addCase(editAmenity.fulfilled, (state, action) => {
        state.loading = false;
        const index = state.amenities.findIndex((a) => a.id === action.payload.id);
        if (index !== -1) {
          state.amenities[index] = action.payload;
        }
      })
      .addCase(editAmenity.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // **Handle Delete Amenity**
      .addCase(deleteAmenity.pending, (state) => {
        state.loading = true;
      })
      .addCase(deleteAmenity.fulfilled, (state, action) => {
        state.loading = false;
        state.amenities = state.amenities.filter((a) => a.id !== action.payload);
      })
      .addCase(deleteAmenity.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

// **Export Reducer**
export default amenitySlice.reducer;
